import React, { useEffect, useState, useRef } from "react";
import { inject, observer } from "mobx-react"; // eslint-disable-line
import { AnalyticsEvent } from "../../components/elements/analytics-event";
import { Logo, PollName } from "../elements";
import { Poll, Poll1v1 } from "../ui";

const PollOverlay = (props) => {
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  const pollType = urlParams.get("poll");
  const isFake = urlParams.get("fake") === "yes";
  useEffect(() => {
    /* Remove for production */
    const url = `${process.env.REACT_APP_LOCAL_URI}/polls/`;
    /* Remove for production */

    let streamer = window.location.href.replace(url, "").split("/");
    if (streamer[0][0] === "@" || streamer[0][0] === "+") {
      streamer[4] = streamer[0][0];
      streamer[0] = streamer[0].substr(1, streamer[0].length);
    } else {
      streamer[2] = "@";
    }

    if (streamer[0] !== "") {
      let streamType = streamer[4],
        username = streamer[0],
        slug = streamer[1],
        pollID = streamer[2];
      /* Remove for production */
      props.overlayStore.socketConnect(
        streamType,
        username,
        slug,
        pollID,
        isFake
      );

      return () => props.overlayStore.socketDisconnect();
    }
  }, []);

  const { pollName } = props.overlayStore;

  // const { name } = props.pollStore;

  return (
    <div>
      {AnalyticsEvent("english", "/", "PLAY LIVE Poll Overlay")}
      {pollType === "multiple" ? (
        <div className="poll-wrapper">
          <PollName>
            <p className="poll_name">{pollName}</p>
          </PollName>
          <Poll />
          <div className="poll_bottom">
            <Logo />
          </div>
        </div>
      ) : (
        ""
      )}
      {pollType === "1v1" ? (
        <div className="poll-1v1-wrapper">
          <PollName>
            <p>Poll: {pollName}</p>
          </PollName>
          <Poll1v1 />
        </div>
      ) : (
        ""
      )}
    </div>
  );
};

export default inject("overlayStore")(observer(PollOverlay));
